// 全局消息插件 - 使用 alert 替代（兼容 React 19）
export const MessagePlugin = {
  success: (content: string) => {
    alert('✓ ' + content);
  },
  error: (content: string) => {
    alert('✗ ' + content);
  },
  info: (content: string) => {
    alert('ℹ ' + content);
  },
  warning: (content: string) => {
    alert('⚠ ' + content);
  },
};

// 空组件，用于兼容
export function MessageProvider({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}
